import type { FC } from "react"
import { Icon, Stack, Text } from "@chakra-ui/react"

import OptionsMenu from "proposal/components/ctas/OptionsMenu"
import { ROUTES } from "common/constants/routes"
import { Ban } from "ui/components/icons/font-awesome/Ban"
import ProposalShareMenuItem from "proposal/components/ctas/ProposalShareMenuItem"

type ProposalCanceledCTAProps = {
  proposalId: string
  slug: string
}
const ProposalCanceledCTA: FC<ProposalCanceledCTAProps> = ({
  proposalId,
  slug,
}) => {
  return (
    <Stack
      align="center"
      color="gray.600"
      direction="row"
      justify={{ base: "center", lg: "right" }}
      spacing={4}
      width="100%"
    >
      <Stack
        align="center"
        direction="row"
        width={{ base: "100%", sm: "auto" }}
      >
        <Icon as={Ban} fill="gray.600" />
        <Text pr={3} textStyle="body.bold.lg">
          Cancelled
        </Text>
      </Stack>
      <OptionsMenu>
        <ProposalShareMenuItem
          url={ROUTES.governance.proposal.id(slug, proposalId, "")}
        />
      </OptionsMenu>
    </Stack>
  )
}

export default ProposalCanceledCTA
